export default __webpack_public_path__ + "static/media/bgAnimals.4b561cd1.png";